import { render, staticRenderFns } from "./preEducationAlone.vue?vue&type=template&id=186dd440&scoped=true"
import script from "./preEducationAlone.vue?vue&type=script&lang=js"
export * from "./preEducationAlone.vue?vue&type=script&lang=js"
import style0 from "./preEducationAlone.vue?vue&type=style&index=0&id=186dd440&lang=scss&scoped=true"
import style1 from "./preEducationAlone.vue?vue&type=style&index=1&id=186dd440&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186dd440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186dd440')) {
      api.createRecord('186dd440', component.options)
    } else {
      api.reload('186dd440', component.options)
    }
    module.hot.accept("./preEducationAlone.vue?vue&type=template&id=186dd440&scoped=true", function () {
      api.rerender('186dd440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/preEducationAlone.vue"
export default component.exports